export const serviceCards = [
  {
    aosDelay: " ",
    icon: "las la-laptop-code",
    title: "Web development",
    description:
      "I craft high-performing and delightful experiences tailored and conversion-focused",
    link: "https://www.instagram.com/mrcoder_xd/",
  },
  {
    aosDelay: "300",
    icon: "las la-laptop-code",
    title: "Graphic Design",
    description:
      "I craft high-performing and delightful experiences tailored and conversion-focused",
    link: "https://www.instagram.com/mrcoder_xd/",
  },
  {
    aosDelay: "600",
    icon: "las la-laptop-code",
    title: "Website management",
    description:
      "I craft high-performing and delightful experiences tailored and conversion-focused",
    link: "https://www.instagram.com/mrcoder_xd/",
  },
];

export const workCards = [
  {
    aosDelay: "",
    img: "./assets/img/project-2.png",
    title: "Landing page",
    description:
      "Developed a real estate website for property listings in Goa.",
    link: "https://MopaGoaPlots.com/",
  },
  {
    aosDelay: "300",
    img: "./assets/img/project-1.png",
    title: "Service website",
    description:
      "Designed and implemented a website for an interior design firm.",
    link: "https://PurpleLaneInteriors.com/",
  },
  {
    aosDelay: "",
    img: "./assets/img/project-4.png",
    title: "Service website",
    description:
      "Innovation that exceeds expectations. Astra is a true template equipped with all the elements you could ever need to put together",
    link: "https://www.instagram.com/mrcoder_xd/",
  },
  {
    aosDelay: "300",
    img: "./assets/img/project-4.png",
    title: "Blog website",
    description:
      "Innovation that exceeds expectations. Astra is a true template equipped with all the elements you could ever need to put together",
    link: "https://www.instagram.com/mrcoder_xd/",
  },
];
